import { TemplateConfig } from '../../template-config.interface';

export const disneyBestPlan: TemplateConfig = {
  id: 'best-plan',
  clientId: 'DISNEY',
  title: 'Tu mejor plan',
  description: 'Template de mejor plan',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/tu_mejor_plan.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/tu_mejor_plan.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/tu_mejor_plan.mp4',
  formFields: [],
  promptTemplate: ''
};
